import { defineStore } from 'pinia'
import storage from '@/plugins/storage'
import http from '@/plugins/api.js'
// import { loading } from '@/plugins/loading'

const USER_ORDER_BY = 'user/orderBy'
const USER_SORT_DIR = 'user/sortDir'
const USER_DAYS = 'user/days'
const USER_PAGE_SIZE = 'user/pageSize'
const USER_SEARCH_TERM = 'user/searchTerm'
const USER_FILTER_BY = 'user/filterBy'
  
export const users = defineStore('users',{
  id: 'users',
  state: () => ({
    user: null,
    users: [],
    roles: [],
    pageSize: storage.session.getItem(USER_PAGE_SIZE) || 10,
    retrospectiveDay: storage.session.getItem(USER_DAYS) || 0,
    searchTerm: storage.session.getItem(USER_SEARCH_TERM) || '',
    sortDir: storage.session.getItem(USER_SORT_DIR) || 'desc',
    orderBy: storage.session.getItem(USER_ORDER_BY) || 'Id',
    filterBy: parseInt(storage.local.getItem(USER_FILTER_BY)) || 9999,
    filterOptions: [],
    isUserChecked: false,
    firmName: null
    }),
  actions: {
    setSearchTerm(text) {
        this.searchTerm = text
        storage.session.setItem(USER_SEARCH_TERM, text)
      },
      setPageSize(pageSize) {
        this.pageSize = pageSize
        storage.session.setItem(USER_PAGE_SIZE, pageSize)
      },
      setRetrospectiveDay(days) {
        this.retrospectiveDay = days
        storage.session.setItem(USER_DAYS, days)
      },
      setSortDir(sortDir) {
        this.sortDir = sortDir
        storage.session.setItem(USER_SORT_DIR, sortDir)
      },
      setOrderBy(orderBy) {
        this.orderBy = orderBy
        storage.session.setItem(USER_ORDER_BY, orderBy)
      },
      setFilterBy(filterBy) {
        this.filterBy = filterBy
        storage.local.setItem(USER_FILTER_BY, filterBy)
      },
      setFilterOptions(data) {
        this.filterOptions = data
      },
      setUserChecked(data) {
        for (let user of this.users.items) {
            if (user.username === data.username) {
              user.isChecked = data.isChecked
            }
          }
          this.isUserChecked = false
          for (let user of this.users.items) {
            if (user.isChecked) {
              this.isUserChecked = true
              break
            }
          }
      },
      async setUserEmail(data) {
        await http.get('user/saveUserEmail', {
            params: data
          })
        if (this.users !== undefined && this.users !== null) {
            if (this.users.items !== null) {
              for (let item of this.users.items) {
                if (item.contact === data.contact) {
                  item.email = data.emailAddress
                  break
                }
              }
            }
        }
      },
      setUser(data) {
        this.user = null
        if (data !== undefined && data !== null) {
        this.user = data
        this.user.user = data.user.toString()
        this.user.timezone = data.timezone !== null ? data.timezone.toString() : null
        }
      },
      addUser(data) {
        this.firmName = data.name
        this.user = {
          firm: data.firm,
          user: '-1',
          contact: -1,
          contactType: 0,
          username: '',
          emailAddress: '',
          firstName: '',
          lastName: '',
          roles: '',
          password: '',
          timezone: '12',
          language: 1,
          laborRate: 0,
          receivesReport: false,
          receivesInvoice: false,
          isInactive: false,
          partnerName: null
        }
      },
      updateUser(data) {
        if (this.user !== null && data !== null) {
            switch (data.name) {
              case 'firm':
                this.user.firm = parseInt(data.value)
                break
              case 'contact':
                this.user.contact = parseInt(data.value)
                break
              case 'contactType':
                this.user.contactType = parseInt(data.value)
                break
              case 'username':
                this.user.username = data.value
                break
              case 'password':
                this.user.password = data.value
                break
              case 'role':
                this.user.roles = data.value
                break
              case 'firstName':
                this.user.firstName = data.value
                break
              case 'lastName':
                this.user.lastName = data.value
                break
              case 'emailAddress':
                this.user.emailAddress = data.value
                break
              case 'language':
                this.user.language = parseInt(data.value)
                break
              case 'timezone':
                this.user.timezone = parseInt(data.value)
                break
              case 'laborRate':
                this.user.laborRate = parseFloat(data.value)
                break
              case 'isInactive':
                this.user.isInactive = data.value
                break
              case 'receivesReport':
                this.user.receivesReport = data.value
                break
              case 'receivesInvoice':
                this.user.receivesInvoice = data.value
                break
              case 'partnerName':
                this.user.partnerName = data.value
                break
              case 'profileImagePath':
                  this.user.profileImagePath = data.value
                  break
            }
          }
      },
      async getRoles(firm) {
        const r = await http.get(`user/roles?firm=${firm}`)
        this.roles = []
        for (let item of r.data) {
          this.roles.push({
            id: item.role,
            value: item.role,
            name: item.name
          })
        }
        return r.data
      },
      async getUser(username) {
        const r = await http.get('user/profile', {
            params: {
              username: username
            }
          })
        this.user = null
        if (r.data !== undefined && r.data !== null) {
          this.user = r.data
          this.user.user = r.data.user.toString()
          this.user.timezone = r.data.timezone !== null ? r.data.timezone.toString() : null
        }
        return r.data
      },
      async getUsers(searchOptions) {
        // const loadingStore = loading()
        // loadingStore.startLoading()
        const r = await http.get('user/users', {
            params: searchOptions
          })
        this.users = []
        this.isUserChecked = false
        if (r.data !== undefined && r.data !== null) {
        if (r.data.items !== undefined && r.data.items !== null) {
            for (let item of r.data.items) {
            item.isChecked = false
            }
        }
        this.users = r.data
        }
        // loadingStore.stopLoading()
        return r.data
      },
      async verifyUsername(username) {
        const r = await http.get(`user/verifyUsername?username=${username}`)
        return r.data
      },
      async saveUser() {
        const r = await http.post('user/saveUser', this.user)
        return r.data
      },
      async deleteUsers(users) {
        const r = await http.post('user/deleteUsers', users)
        return r.data
      },
      async saveCredentials(data) {
        const r = await http.post('user/saveCredentials', data)
        return r.data
      },
      async activateUsers(users) {
        const r = await http.post('user/activateUsers', users)
        for (let user of users) {
          var status = false
          if (user.token === '1') {
            status = true
          }
          for (let user of this.users.items) {
            if (user.username === user.username) {
              user.isChecked = status
            }
          }
          this.isUserChecked = false
          for (let user of this.users.items) {
            if (user.isChecked) {
              this.isUserChecked = true
              break
            }
          }
        }
        return r.data
      }
  }
})

